import styled from '@emotion/styled';

export const InputLabel = styled.span`
  position: absolute;
  top: 50%;
  left: ${({ theme }) => theme.spacing(4)};
  transform: translateY(-50%);
  color: ${({ theme }) => theme.palette.colors.gray[400]};
  background-color: ${({ theme }) => theme.palette.colors.white};
  padding: 0;
  transition: all 0.1s ease-out;
  cursor: text;
  line-height: ${({ theme }) => theme.lineHeights.xs};
  font-size: ${({ theme }) => theme.fontSizes.f3};
  font-weight: ${({ theme }) => theme.fontWeights.normal};
  font-family: ${({ theme }) => theme.fontFamilies.body};
`;
